<template>
	<div class="Box">
		<!-- <div class="Menu">
			<ul>
				<li class="menuText" @click="Menuscroll(1)">公司介绍</li>
				<li class="menuText" @click="Menuscroll(2)">工作环境</li>
				<li class="menuText" @click="Menuscroll(3)">联系我们</li>
			</ul>
		</div> -->
		<!-- 公司介绍 -->
		<div class="title infoHeight">
			<div class="bgimg">
				<img src="../assets/img/bb01.png" alt="">
			</div>
			<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)" >
				<p class="name">公司介绍</p>
				<p class="english">COMPANY PROFILE</p>
				<!-- <p class="det">{{info.title}}</p> -->
			</div>
		</div>
		<!-- 内容 -->
		<div class="content">
			<div class="contentImg">
				<img :src="info.pic" alt="">
			</div>
			<div class="contentText" v-html="info.textBody">
				{{info.textBody}}
			</div>
		</div>
		<!-- 工作环境 -->
		<div class="title envHight">
			<div class="bgimg" >
				<img src="../assets/img/bb02.png" alt="">
			</div>
			<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
				<p class="name">工作环境</p>
				<p class="english">OFFICE ENVIRONMENT</p>
			</div>
		</div>
		<div class="environment">
			<div class="trans">
				<swiper ref="mySwiper" :options="swiperOptions" class="banner">
					<swiper-slide v-for="ele in environment" :key="ele.index">
						<div class="trans_li">
							<div class="trans_img">
								<img :src="ele.pic" alt="">
							</div>
							<div class="trans_name">{{ele.title}}</div>
						</div>
					</swiper-slide>
				</swiper>
				<div class="btn left"><img src="../assets/img/left.png"></div>
				<div class="btn right"><img src="../assets/img/right.png"></div>
			</div>

		</div>
		<!-- 联系我们 -->
		<div class="title contactHeight">
			<div class="bgimg">
				<img src="../assets/img/bb03.png" alt="">
			</div>
			<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
				<p class="name">联系我们</p>
				<p class="english">CONTACT US</p>
			</div>
		</div>
		<div class="contact">
			<div class="contactImg">
				<img :src="contact.pic" alt="">
			</div>
			<div class="contactText">
				<div style="width: 100%; height: 0.2rem;"></div>
				<p style="font-weight: 600;">锐艺多吉文化传播有限公司</p>
				<p style="font-weight: 600;">AmazingRay Media Communication Co.,Ltd.</p>
				<p>地址：{{companyAddress}}</p>
				<p>Address：Unit B1 No. 39 Shenlu Street, Chaoyang District, Beijing</p>
				<p>Fax：{{companyCode}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  Tel：{{companyPhone}}  </p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'
	export default {
		name: 'about',
		components: {
			Swiper,
			SwiperSlide
		},
		directives: {
			swiper: directive
		},
		data() {
			return {
				val:"",
				swiperOptions: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right',
						prevEl: '.left',
					},
					slidesPerView: 4, //页面可视数（网格）
				},
				info: {}, //公司简介
				environment: [], //工作环境
				contact: {}, //联系我们
				companyAddress: "",
				companyPhone: "",
				companyMail: "",
				infoHeight: "", //公司介绍的高度
				envHeight: "", //工作环境的高度
				conHeight: "", //联系我们的高度
				queryNum: "", //监听当前路由是否发生变化
				companyCode: "",
			}
		},
		watch: {
			$route: {
				handler() {
					this.queryNum = this.$route.query.num;
					// this.getDetail();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
			queryNum(newValue, old) {
				if (newValue != old) {
					console.log("页面的值由" + old + "变为" + newValue)
					if (newValue == 11) {
						this.getinfo()
					} else if (newValue == 12) {
						this.getEnvironment()
					} else if (newValue == 13) {
						this.getContent()
					}
				}
			}
		},
		methods: {
			
			//鼠标移入标题
			titleEnter(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1.1,1.1)'
				bgimg.style.transitionDuration="1s"
			},
			//鼠标移出标题
			titleLeave(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1,1)'
				bgimg.style.transitionDuration="1s"
			},
			
			//获取公司介绍
			getinfo() {
				this.$api.get(this.$httpApi + this.$path.INDEX_INFO).then(res => {
					// console.log("公司简介", res.data)
					this.info = res.data.data
					//滚动到公司简介的高度
					this.$nextTick(() => {
						console.log('公司简介23456789')
						//获取高度
						let infoHeight = document.querySelector('.infoHeight')
						this.infoHeight = infoHeight.offsetTop
						//设置高度
						if (this.$route.query.num == 11) {
							let _this = this;
							setTimeout(function() {
								document.body.scrollTop = _this.infoHeight
								document.documentElement.scrollTop = _this.infoHeight
							}, 5);
						}
						console.log(infoHeight.offsetTop)
					})
				}).catch(err => {})
			},
			//获取工作环境
			getEnvironment() {
				this.$api.get(this.$httpApi + this.$path.INDEX_ENVIRIONMENT, {
					offset: 0,
					limit: 8
				}).then(res => {
					this.environment = res.data.data
					//滚动到工作环境的高度
					this.$nextTick(() => {
						//获取高度
						let envHight = document.querySelector('.envHight')
						this.envHight = envHight.offsetTop
						console.log('工作环境高度', this.envHight)
						//设置高度
						if (this.$route.query.num == 12) {
							let _this = this;
							setTimeout(function() {
								document.body.scrollTop = _this.envHight
								document.documentElement.scrollTop = _this.envHight
							}, 5);
						}
					})
				}).catch(err => {})
			},
			//联系我们
			getContent() {
				this.$api.get(this.$httpApi + this.$path.INDEX_CONTACT).then(res => {
					console.log("联系我们", res.data)
					this.contact = res.data.data
					this.$nextTick(() => {
						//获取高度
						let contactHeight = document.querySelector('.contactHeight')
						this.conHeight = contactHeight.offsetTop
						//设置高度
						if (this.$route.query.num == 4 || this.$route.query.num == 13) {
							let _this = this;
							setTimeout(function() {
								document.body.scrollTop = _this.conHeight
								document.documentElement.scrollTop = _this.conHeight
							}, 5);
						}
					})
				}).catch(err => {})
			},
			//获取公司地址和电话
			getOther() {
				this.$api.get(this.$httpApi + this.$path.INDEX_DATALIST).then(res => {
					console.log("首页其他数据", res.data);
					this.companyAddress = res.data.data.companyAddress; //地址
					this.companyPhone = res.data.data.companyPhone; //公司电话
					this.companyMail = res.data.data.companyMail; //邮箱
					this.companyCode = res.data.data.companyCode; //传真
				}).catch(err => {})
			},
			//页面滚动
			Menuscroll(value) {
				//滚动到公司简介的高度
				if (value == 1) {
					this.$nextTick(() => {
						console.log('公司简介')
						//获取高度
						let infoHeight = document.querySelector('.infoHeight')
						this.infoHeight = infoHeight.offsetTop
						//设置高度
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.infoHeight
							document.documentElement.scrollTop = _this.infoHeight
						}, 5);
					})
				} else if (value == 2) {
					//滚动到工作环境的高度
					this.$nextTick(() => {
						//获取高度
						let envHight = document.querySelector('.envHight')
						this.envHight = envHight.offsetTop
						console.log('工作环境高度', this.envHight)
						//设置高度
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.envHight
							document.documentElement.scrollTop = _this.envHight
						}, 5);
					})
				} else if (value == 3) {
					this.$nextTick(() => {
						//获取高度
						let contactHeight = document.querySelector('.contactHeight')
						this.conHeight = contactHeight.offsetTop
						//设置高度
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.conHeight
							document.documentElement.scrollTop = _this.conHeight
						}, 5);
					})
				}

			}
		},
		mounted() {
			this.queryNum = this.$route.query.num;
			this.getinfo()
			this.getEnvironment()
			this.getContent()
			this.getOther()
			this.$router.afterEach((to, from, next) => {
				window.scrollTo(0, 0)
			})
		},
		// updated() {
		// 	console.log("此时页面有修改",this.$route.query)
		// },

	}
</script>

<style scoped>
	.Box {
		width: 100%;
		box-sizing: border-box;
	}

	/* 菜单栏 */
	.Menu {
		width: 100%;
		height: 0.4rem;
		background-color: #05060a;
		line-height: 0.20rem;
		padding-left: 5.10rem;
		box-sizing: border-box;
	}

	.menuText {
		color: #ffffff;
		font-size: 0.18rem;
		float: left;
		margin-right: 1rem;
		cursor: pointer;
	}

	/* 标题开始 */
	.title {
		width: 100%;
		height: 2.40rem;
		padding: 0 1.32rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		position: relative;
		border-bottom: 0.01rem solid #666666;
	}

	.bgimg {
		width: 1.86rem;
		height: 1.72rem;
		position: absolute;
		left: 1.32rem;
		top: 0.35rem;
		
	}

	.bgimg img {
		/* width: 100%; */
		height: 100%;
		
	}

	.text {
		min-width: 4.80rem;
		height: 2.00rem;
		position: absolute;
		left: 1.4rem;
		top: 0.20rem;
		z-index: 2;
	}
	.text:hover{
		cursor: pointer;
	}

	.name {
		color: #FFFFFF;
		font-size: 0.32rem;
		text-align: left;
		margin-top: 0.80rem;
		line-height: 0.50rem;
		font-weight: 500;
		letter-spacing: 0.03rem;
	}

	.english {
		color: #FFFFFF;
		font-size: 0.21rem;
		line-height: 0.30rem;
		font-weight: 5.00;
		text-align: left;
		letter-spacing: 0, 06rem;
	}

	.det {
		color: #d5d5d5;
		font-size: 0.14rem;
		line-height: 0.20rem;
		position: absolute;
		bottom: -0.05rem;
		left: 0;
	}

	/* 标题结束 */
	/* 内容 */
	.content {
		width: 100%;
		/* height: 7.15rem; */
		background-color: #0F0F0F;
		padding: 0.70rem 0;
		box-sizing: border-box;
		border-bottom: 0.01rem solid #666666;
	}

	.contentImg {
		width: 16.42rem;
		height: 3.84rem;
		margin: 0 auto;
		margin-bottom: 0.70rem;
	}

	.contentImg img {
		width: 100%;
		height: 100%;
	}

	.contentText {
		width: 16.40rem;
		font-weight: 300;
		margin: 0 auto;
		height: auto;
		color: #d5d5d5;
		line-height: 0.35rem;
		font-size: 0.18rem;
		text-align: justify;
	}

	.environment {
		width: 100%;
		height: 6.40rem;
		padding: 1.20rem 1.36rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		border-bottom: 0.01rem solid #666666;
	}

	.trans {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.banner {
		width: 15.30rem;
		height: 4.00rem;
	}

	.btn {
		width: 0.30rem;
		height: 0.56rem;
		outline: none;
		position: absolute;
		cursor: pointer;
	}

	.left {
		position: absolute;
		left: 0;
		top: 1.28rem;
	}

	.right {
		position: absolute;
		right: 0;
		top: 1.28rem;
	}

	.left>img,
	.right>img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.transVisible {
		width: 15.52rem;
		height: 4.00rem;
		margin: 0 auto;
	}

	.trans_ul {
		width: auto;
		height: 4.00rem;
		/* 	display: inline-block !important;
		*display: inline !important;
		*zoom: 1 !important; */
		display: flex;
		flex-wrap: nowrap;
		/* overflow: hidden; */
	}

	.trans_ul::after {
		overflow: hidden;
	}

	.trans_li {
		width: 3.70rem;
		height: 100%;
		/* float: left; */
		margin-right: 0.24rem;
	}

	.trans_li:last-child {
		margin: 0;
	}

	.trans_img {
		width: 100%;
		height: 3.25rem;
	}

	.trans_img img {
		width: 100%;
		height: 100%;
	}

	.trans_name {
		width: 100%;
		height: 0.24rem;
		margin-top: 0.50rem;
		text-align: center;
		color: #FFFFFF;
		font-size: 0.24rem;
		font-weight: 6.00;
		line-height: 0.24rem;
		font-weight: 600;
	}

	/* 联系我们 */
	.contact {
		width: 100%;
		/* height: 7.15rem; */
		height: 5.6rem;
		background-color: #0F0F0F;
		padding: 0.58rem 1.34rem;
		box-sizing: border-box;
	}

	.contactImg {
		width: 8rem;
		height: 4.2rem;
		float: left;
	}

	.contactImg img {
		width: 100%;
		height: 100%;
	}

	.contactText {
		width: 8.00rem;
		height: 6.00rem;
		float: left;
		padding-left: 0.56rem;
		box-sizing: border-box;
		text-align: left;
		color: #fcfcfc;
		font-size: 0.20rem; 
		/* font-size: 0.24rem; */
	}

	.contactText p {
		margin-bottom: 0.46rem;
		/* margin-bottom: 0.4rem; */
	}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue